/**
 * Extracts the filename from a Content-Disposition header value.
 *
 * Prefers filename* (RFC 5987, percent-encoded UTF-8) over filename= so that
 * filenames containing commas, spaces or non-ASCII characters are preserved.
 * Falls back to the plain filename= value for ASCII-only names.
 */
export function extractFilename(contentDisposition: string): string {
  const starMatch = /filename\*=UTF-8''([^;\s\r\n]+)/i.exec(contentDisposition);
  if (starMatch) {
    return decodeURIComponent(starMatch[1]);
  }
  const quotedMatch = /filename="([^"]+)"/i.exec(contentDisposition);
  if (quotedMatch) {
    return quotedMatch[1];
  }
  return contentDisposition.replace('attachment; filename=', '');
}
